import { DateRangeSelect } from "@4uhub/lib4uhub";
import { MenuItem, Stack, TextField } from "@mui/material";
import { memo, useState } from "react";

import FiltersActions from "../../../../components/FiltersActions/FiltersActions";

export interface IFilterParams {
  CreatedStart: Date | null;
  CreatedEnd: Date | null;
  Status: string;
  PhysicianIdentifier: string;
  PatientEncounterNumber: string;
}

interface IMacroFilterProps {
  value: IFilterParams;
  onFilter: (value: IFilterParams) => void;
}

const MacroFilter = ({ value, onFilter }: IMacroFilterProps) => {
  const [filter, setFilter] = useState(value);
  const [resetDateRange, setResetDateRange] = useState(false);

  const updateFilter = (patch: Partial<IFilterParams>) => {
    setFilter((current) => ({ ...current, ...patch }));
  };

  const cleanFilter = () => {
    const cleanValue: IFilterParams = {
      CreatedStart: null,
      CreatedEnd: null,
      Status: "",
      PhysicianIdentifier: "",
      PatientEncounterNumber: "",
    };

    setFilter(cleanValue);
    onFilter(cleanValue);
    setResetDateRange((current) => !current);
  };

  const hasFilters = Object.values(filter).some(
    (item) => item !== null && item !== "",
  );

  return (
    <Stack direction="row" gap={1.5} alignItems="center" flexWrap="wrap">
      <DateRangeSelect
        setStartDate={(date) => updateFilter({ CreatedStart: date })}
        setEndDate={(date) => updateFilter({ CreatedEnd: date })}
        setEnableFields={() => {}}
        resetToToday={resetDateRange}
      />
      <TextField
        select
        size="small"
        label="Status"
        value={filter.Status}
        onChange={(event) => updateFilter({ Status: event.target.value })}
        sx={{ minWidth: 150 }}
      >
        <MenuItem value="">Todos</MenuItem>
        <MenuItem value="PENDING">Pendente</MenuItem>
        <MenuItem value="PROCESSING">Processando</MenuItem>
        <MenuItem value="SENT">Enviado</MenuItem>
        <MenuItem value="ERROR">Erro</MenuItem>
      </TextField>
      <TextField
        size="small"
        label="Médico"
        value={filter.PhysicianIdentifier}
        onChange={(event) =>
          updateFilter({ PhysicianIdentifier: event.target.value })
        }
      />
      <TextField
        size="small"
        label="Nº Atendimento"
        value={filter.PatientEncounterNumber}
        onChange={(event) =>
          updateFilter({
            PatientEncounterNumber: event.target.value.replace(/\D/g, ""),
          })
        }
      />
      <FiltersActions
        onFilter={() => onFilter(filter)}
        onClean={cleanFilter}
        showCleanBtn={hasFilters}
      />
    </Stack>
  );
};

export default memo(MacroFilter);
